<div class="container container_type_main">
  <div class="subtitle h2 mt-32">{{ 'subscriber-melodies-page.title' | translate }}</div>
  <div *ngIf="isLoading" class="modal__loader with-icon"></div>

  <ng-container *ngIf="!isLoading">
  <div class="filters" *ngIf="melodies?.length > 0">
    <div class="filters__item" [class.filters__item-active]="filter == Filter.PLAYING_FOR_ALL" (click)="updateFilter(Filter.PLAYING_FOR_ALL)">
      <div class="filters__link">{{ 'subscriber-melodies-page.melodies-for-all' | translate }}</div>
    </div>
    <div class="filters__item" [class.filters__item-active]="filter == Filter.WITH_RULES" (click)="updateFilter(Filter.WITH_RULES)">
      <div class="filters__link">{{ 'subscriber-melodies-page.melodies-with-rules' | translate }}</div>
    </div>
    <div class="filters__item" [class.filters__item-active]="filter == Filter.NOT_PLAYING" (click)="updateFilter(Filter.NOT_PLAYING)">
      <div class="filters__link">{{ 'subscriber-melodies-page.melodies-off' | translate }}</div>
    </div>
  </div>

  <div class="info-hint" *ngIf="standardMelodyPlaying && filter == Filter.PLAYING_FOR_ALL">{{ 'subscriber-melodies-page.melodies-off-hint' | translate }}</div>

  <div class="songs-list" *ngIf="filteredMelodies?.length > 0 else melodiesEmpty">
    <div class="songs-list__item" *ngFor="let melody of filteredMelodies" app-subscriber-melody-item [melody]="melody" [showControls]="true"></div>
  </div>

  <app-mobile-apps-banner></app-mobile-apps-banner>
  </ng-container>
</div>

<ng-template #melodiesEmpty>
  <div class="page-notfound">
    <div class="page-notfound__img"></div>
    <div class="page-notfound__name h2">{{ 'subscriber-melodies-page.melodies-empty-title' | translate }}</div>
    <div class="page-notfound__text" *ngIf="!melodies || melodies.length == 0" [innerHtml]="'subscriber-melodies-page.melodies-empty-text' | translate"></div>
    <div class="page-notfound__text" *ngIf="melodies?.length > 0 && filter == Filter.PLAYING_FOR_ALL">{{ 'subscriber-melodies-page.melodies-empty-for-all' | translate }}</div>
    <div class="page-notfound__text" *ngIf="melodies?.length > 0 && filter == Filter.WITH_RULES">{{ 'subscriber-melodies-page.melodies-empty-rules' | translate }}</div>
    <div class="page-notfound__text" *ngIf="melodies?.length > 0 && filter == Filter.NOT_PLAYING">{{ 'subscriber-melodies-page.melodies-empty-not-playing' | translate }}</div>
    <div class="page-notfound__button">
      <a class="button" *ngIf="!melodies || melodies.length == 0" routerLink="/genres">{{ 'subscriber-melodies-page.to-genres-button' | translate }}</a>
    </div>
  </div>
</ng-template>
